import { useEffect, useRef, useState } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "./videojs.css";

const VideoPlayer = (props) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const [playbackRate, setPlaybackRate] = useState(1);
  const { options, onReady } = props;

  useEffect(() => {
    let player = playerRef.current;
    const videoElement = document.createElement("video-js");
    videoElement.classList.add("vjs-big-play-centered");
    videoRef.current.appendChild(videoElement);
    player = videojs(videoElement, options);

    return () => {
      if (player) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [options, videoRef, playerRef]);

  return (
    <>
      <div data-vjs-player>
        <div ref={videoRef} className={props.className} />
      </div>
    </>
  );
};

export default VideoPlayer;
